import React from 'react';

const CustomLink = link => <a href={link.path} className={link.class}>{link.label}</a>;

export default CustomLink;
